/*// import ScrollOut
import ScrollOut from "scroll-out";

// Fade Up Effect Animation on any item with the .fadeinup class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinup',
    targets: '.home #full-width-page-wrapper .wp-block-column:has(hr), .home #full-width-page-wrapper .wp-block-columns .wp-block-column:first-child:has(ul)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInUp');
        // force reflow
        void el.offsetWidth;
        // re-add the animated cl
        el.classList.add('animate__animated', 'animate__fadeInUp');
        //el.animate([{ opacity: 0 }, { opacity: 1 }], 1000);
    }
});
// Fade Right Effect Animation on any item with the .fadeinright class
ScrollOut({
    //targets:'.home #full-width-page-wrapper .wp-block-columns',
    //targets:'.fadeinright',
    targets: '.home #full-width-page-wrapper .wp-block-columns .wp-block-column:last-child:has(h2, .wp-block-buttons)',
    onShown: function (el) {
        // remove the class
        el.classList.remove('animate__animated', 'animate__fadeInRight');
        // force reflow
        void el.offsetWidth;
        // re-add the animated cl
        el.classList.add('animate__animated', 'animate__fadeInRight');
    }
});*/
//
import Lightbox from './bs5-lightbox';

const options = {
    keyboard: true
};

document.querySelectorAll('[data-toggle="lightbox"]').forEach((el) => el.addEventListener('click', (e) => {
    e.preventDefault();
    const lightbox = new Lightbox(el, options);
    lightbox.show();
}));
//
// import Swiper JS
import Swiper from 'swiper';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';

const swiper = new Swiper('.swiper', {
    // Optional parameters
    //direction: 'vertical',
    modules: [Autoplay, Navigation, Pagination],
    loop: true,
    slidesPerView: 1,
    breakpoints: {
        992: {
            slidesPerView: 2,
            spaceBetween: 24
        }
    },
    autoHeight: true, // Make slides equal height
    autoplay: {
        delay: 10000,
    },
    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
});

// Floating booking button — dismissible for the rest of the browser session.
// remove() rather than a hidden class: the wrapper's d-lg-block carries
// !important, so it would beat both [hidden] and a plain display:none.
const floatingBooking = document.getElementById('floating-booking');
const floatingBookingClose = document.getElementById('floating-booking-close');

if (floatingBooking) {
    let dismissed = false;
    // Storage can be blocked or throw. Failing to read means show the button,
    // which is the safe default.
    try { dismissed = sessionStorage.getItem('yc-booking-dismissed') === '1'; } catch (e) {}

    if (dismissed) {
        floatingBooking.remove();
    } else if (floatingBookingClose) {
        floatingBookingClose.addEventListener('click', function () {
            // If the write fails the button still closes; it just returns on the next page.
            try { sessionStorage.setItem('yc-booking-dismissed', '1'); } catch (e) {}
            floatingBooking.remove();
        });
    }
}
//

// Add class to columns with two children
const parents = document.querySelectorAll('.wp-block-columns');

parents.forEach(parent => {
  const children = parent.children;
  if (children.length === 2) {
    parent.classList.add('has-two-children');
  }
});
//

jQuery(document).ready(function ($) {
    $('a[href^="#block-"]').on('click', function (e) {
        e.preventDefault();
        //
        var headerHeight = $('#main-nav').outerHeight();
        var link = $(this).attr('href');
        var linkOffset = $(link).offset().top - headerHeight;
        //
        $('html, body').animate({
            scrollTop: linkOffset
        }, 'slow');
    });
});